<template>
  <div class="btn" @click="handleBtnClicked">
    <div class="btn-bg"></div>
    <div class="btn-label">{{label}}</div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api';

const NAMESPACE = '[Button]';

export default {
  name: 'Button',
  components: {

  },
  props: {
    label: {
      type: String,
      default: 'LABEL',
    },

  },

  setup(props, context) {
    const {
      $route,
      $store,
    } = context.root;

    // Properties

    // Hooks
    onMounted(() => {
      console.log(NAMESPACE, 'onMountd()');
    })


    // Methods
    const handleBtnClicked = () => {
      // console.log('handleBtnClicked');

      context.emit('clicked');
    }

    return {

      handleBtnClicked,
    }
  }
}
</script>

<style lang="scss" scoped>
$btn-padding: 0.2em;
// $btn-x-padding: 0.1em;
// $btn-y-padding: 0.1em;

.btn {
  // background-color: #f8e201;
  @include font-knewave;
  overflow: hidden;
  font-size: 2.0rem;
  color: #000000;
  // padding: calc(0.5em+10px) calc(2.6em+10px);
  // padding-top: calc(0.5em + 0.1em);
  padding-top: calc(0.5em + #{$btn-padding});
  padding-bottom: calc(0.5em + #{$btn-padding});
  padding-left: calc(2.6em + #{$btn-padding});
  padding-right: calc(2.6em + #{$btn-padding});
  // box-shadow: 7px 7px 0px #129fc9;
  border-radius: 4px;

  &::before {
    position: absolute;
    top: #{$btn-padding};
    left: #{$btn-padding};
    width: calc(100% - #{$btn-padding*2});
    height: calc(100% - #{$btn-padding*2});
    content: '';
    display: block;
    background-color: $bg-shadow-blue-color;
    border-radius: 4px;
  }

  &::after {

  }
}

.btn-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - #{$btn-padding*2});
  height: calc(100% - #{$btn-padding*2});
  background-color: $bg-yellow-color;
  border-radius: 4px;
}

.btn-label {
  // font-size: 1em;
  position: relative;
  top: #{-$btn-padding};
  left: #{-$btn-padding};
}

@include mobile {

}

@include mobile-small {
  .btn {
    font-size: 1.8rem;
  }
}

@include height-medium {

}

@include height-short {
  .btn {
    font-size: 1.8rem;
  }
}
</style>
